import { SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { CoordinateWithData } from './map.type';

export const clusterOptions = {
  maxZoom: 10, // Clusters break apart beyond zoom level 16
  zoomOnClick: false, // Enable zoom on cluster click
  averageCenter: true, // Center clusters at average marker positions
};

export const getClusterAlgorithm = () => {
  return new SuperClusterAlgorithm({ radius: 75, minPoints: 5, maxZoom: 10 });
};

export const offsetDuplicateCoordinates = (coordinates: CoordinateWithData[]): CoordinateWithData[] => {
  const coordMap: Record<string, CoordinateWithData[]> = {};

  coordinates.forEach(marker => {
    const lat = Number(marker?.lat);
    const lng = Number(marker?.lng);
    const key = `${lat}-${lng}`;

    if (!coordMap[key]) {
      coordMap[key] = [];
    }
    coordMap[key].push({ ...marker });
  });

  return Object.values(coordMap).flatMap((markers, index) =>
    markers.map((marker, idx) => {
      const offset = idx * 0.0001; // Offset based on duplicate index
      return {
        ...marker,
        lat: marker.lat + offset,
        lng: marker.lng + offset,
      };
    }),
  );
};

export const mapControlStyles = {
  margin: '10px',
  background: 'white',
  borderRadius: '4px',
  boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
};
